import React from "react";
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import ReactModal from 'react-modal';
import styled from 'styled-components';
import QRCode from 'qrcode.react';
import jsPDF from 'jspdf';
import { CSVLink } from 'react-csv';
import * as appInfo from '../../config/config.json'

// icon imports
import {
  PinDrop,
} from '@material-ui/icons';

// material ui core imports
import {
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
	Grid,
	CircularProgress,
	TextField,
	InputLabel,
	InputAdornment,
} from "@material-ui/core";

import { Redirect } from "react-router-dom";

// home-grown component imports
import {
  RegularCard,
  P,
  Button,
  SnackbarContent,
  ItemGrid,
  CustomInput,
  UploadButton,
} from "../../components";
// reducer action imports
import Maps from '../Maps/Maps';
import {
	createNewReward,
	loadRewards,
	updateReward,
	deleteReward,
	getSettings,
	saveRewardSettings,
	getUserData,
} from './reducer/actions';

// Reporting-related imports
//BMS Loyalty GK-16
import ReactTable from 'react-table';
import "react-table/react-table.css"
// header contains base64 string for the letterhead image for the generated pdf
import header from "./Header.js";

// modal div styles
const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 20px;
  border-bottom: 1px solid rgba(153, 153, 153, 0.7);
`
const ModalContent = styled.div`
  position: relative;
  padding: 0px 20px;
  overflow: hidden;
  padding-bottom: 20px;
  line-height: 50px;
`
const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(153, 153, 153, 0.7);
`

// modal style sheets
const customModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(15, 102, 128, 0.5)'
  },
  content: {
    top: 'calc(50% + 30px)',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px !important',
    width: '572px'
  }
};

// Columns for Reporting section data
const columns = [{
	Header: 'Name',
	accessor: 'name',
},{
	Header: 'Email',
	accessor: 'email',
},{
	Header: 'Reward Points',
	accessor: 'points',
},{
	Header: 'Total Points Earned',
	accessor: 'totalPointsEarned',
},{
	Header: 'Last Check-In',
	accessor: 'lastCheckIn',
},{
	Header: 'Redemptions',
	accessor: 'redemptions',
},{
	Header: 'Last Redemption',
	accessor: 'lastRedemption',
}];

// Rodents of Unusual Size? I don't believe they exist.

// class declaration
class RewardsView extends React.Component {
	// constructor
	constructor(props) {
    super(props);
		this.state = {
			/* modal state components */
			showModal: false,
			isLoading: false,
		title: '',
		location: null,
				/* check-in state components */
		delay: 0,
		loyaltyCardBackground: null,
		geoRadius: 0.1,
		points: 0,
		reward: 0,
		settingsLoaded: false,
		selectedReward: null,
		geoRequiredOnScan: false,
		enableCheckin: true,
		enableQR: true,
		headers: [
			{ label: "Name", key: "name" },
			{ label: "Email", key: "email" },
			{ label: "Reward Points", key: "points" },
			{ label: "Total Points Earned", key: "totalPointsEarned" },
			{ label: "Last Check-In", key: "lastCheckIn" },
			{ label: "Redemptions", key: "redemptions" },
			{ label: "Last Redemption", key: "lastRedemption" }
		],
    };
  }

	// retrieve settings for Rewards
	loadSettings() {
	  this.props.getSettings(settings => this.setState({
	    settingsLoaded: true,
	    loyaltyCardBackground: settings.loyaltyCardBackground || null, /* image */
	    geoRadius: settings.geoRadius || 0.1, /* Maximum check-in distance */
	    points: settings.points || 1, /* points necessary to redeem an award */
	    delay: settings.delay || 1, /* how many hours until next check-in possible */
		reward: settings.reward || '$1', /* what points can be redeemed for */
		geoRequiredOnScan: settings.geoRequiredOnScan || false,
		enableCheckin: settings.enableCheckin || false,
		enableQR: settings.enableQR || false,
	  }))
	}

	// load settings, load rewards, switch loading on
  componentWillMount() {
    this.setState({ isLoading: true });
    this.loadSettings();
		this.props.getUserData(this.onSuccess.bind(this), this.onError.bind(this));
		this.props.loadRewards(this.onSuccess.bind(this), this.onError.bind(this));
  }

	// save user changes to Rewards settings
  saveRewardSettings() {
    this.props.saveRewardSettings({
	  geoRadius: parseFloat(this.state.geoRadius)? parseFloat(this.state.geoRadius): 0.1,
	  geoRequiredOnScan: this.state.geoRequiredOnScan,
	  enableCheckin: this.state.enableCheckin,
	  enableQR: this.state.enableQR,
      points: this.state.points,
      delay: this.state.delay,
      loyaltyCardBackground: this.state.loyaltyCardBackground,
      reward: this.state.reward,
    }, () => this.loadSettings());
  }

	// on success, close modal and switch off loading
	onSuccess() {
		this.setState({ isLoading: false, showModal: false });
	}

	// upon encountering an error, print error to console and close modal
	onError(error) {
		switch (error.code) {
      case 401:
          console.log(error);
        break;
      default:
        console.log(error);
        break;
    }
    this.setState({ isLoading: false, showModal: false });
	}
	// switch modal on
	_onShowModal() {
		this.setState({ showModal: true });
	}

	// switch loading on when adding a reward
	// opens modal with Title input
	// TODO: Edit rewards?
	_onAddReward() {
		this.setState({ isLoading: true });

		this.props.createNewReward({
			title: this.state.title
		}, this.onSuccess.bind(this), this.onError.bind(this));
	}
	// when modal is closed, switch it off
  _onCloseModal() {
		this.setState({ showModal: false });
	}

	// Change set geo-checkin coordinates
  onChangeCoords({remove = false} = {}) {
    const {
      location = {},
    }  = this.state;
		// set Latitude and Longitude to user-provided values
    const lat = location != null ? Number(location.lat) : null;
    const lng =  location != null ? Number(location.lng) : null;
		// if nothing is null and everything is equivalent, create a New Location
    const newLocation = !remove && lat != null && lng != null ? {lat, lng} : null;
		// and then log it
    console.log('Location', newLocation);
		// and then set it to state
    this.setState({ location: newLocation });
		// and then update the chosen Reward accordingly
    this.props.updateReward(
      this.state.selectedReward,
      {
        location: newLocation,
      },
      () => console.log('reward updated')
    );
  }

	// delete a Reward entirely
  onDeleteReward() {
		this.props.deleteReward(
    	this.state.selectedReward,
    	() => this.props.loadRewards(this.onSuccess.bind(this), this.onError.bind(this))
  	);
		this.setState({selectedReward: null});
  }

  /** Neither of the following functions are used, consider removing
   * Success in send one-time reward
   */
  onSendSuccess() {

  }

  /**
   * Fail in send one-time reward
   */
  onSendError(error) {

  }

	// when a Reward is clicked on, show the appropriate values
  onSelectReward (r) {
   this.setState({
      selectedReward: r.id,
      location: r.location || null,
    });
  }

	// allows saving of the QR code that the app scans for rewards
  downloadQR(reward) {
    const canvas = document.querySelector('.HpQrcode > canvas');
    const tempLink = document.createElement('a');
    tempLink.href = canvas.toDataURL();
    tempLink.setAttribute('download', `${reward.title}.png`);
    tempLink.click();
  }

	// take user defined coordinates and
	parseEnteredCoord(val = '') {
		// if it's not a string, return immediately
		if (typeof val !== 'string') {
			return false;
		}
		// if the string is pure whitespace, return
		if (val.trim() === '') {
			return undefined;
		}
		// replace commas with dots and remove every other non-number character
		let stringValue = val.trim().replace(',', '.').replace(/[^0-9.-]/g, '');

		const replaceButFirst = (strOriginal, strToReplace, shouldBeFirst = false) => {
			const n = strOriginal.indexOf(strToReplace);
			const firstPart = strOriginal.substring(0, n !== 0 && shouldBeFirst ? n : n + 1);
			let tempString = strOriginal.substring(n + 1);
			return firstPart + tempString;
		}

		stringValue = replaceButFirst(stringValue, '-', true);
		stringValue = replaceButFirst(stringValue, '.');

		//const parsed = parseFloat(stringValue);
		//return parsed === parsed ? stringValue : false;
		return stringValue;
	}

	// display the Map where the location can be picked out
	// or defaults to the corner of 5th and W. 34th, Manhattan
	// if location is still null
  renderMap() {
    return !this.state.location ? (
      <FormControlLabel
        control={
          <Checkbox
            checked={false}
            onChange={(e, c) => {this.setState({ location: {
             lat: 40.748817,
             lng: -73.985428
           }})}}
        />
        }
        label="Enable Geo Check-in"
      />
      ) : (
      <Grid container>
       <ItemGrid xs={12} sm={12} md={6}>
          <CustomInput
            labelText="lat"
            formControlProps={{
              fullWidth: true,
              type: 'number'
            }}
						/* input location latitude */
            inputProps={{
              value: this.state.location.lat || '',
              onChange: (evt) => this.setState({
                location: {
                  ...this.state.location,
                  lat: this.parseEnteredCoord(evt.target.value)
                }})
            }}
          />
        </ItemGrid>
        <ItemGrid xs={12} sm={12} md={6}>
          <CustomInput
            labelText="lng"
            formControlProps={{
              fullWidth: true,
              type: 'number'
            }}
						/* input location longitude*/
            inputProps={{
              value: this.state.location.lng || '',
              onChange: (evt) => this.setState({
                location: {
                  ...this.state.location,
                  lng: this.parseEnteredCoord(evt.target.value)
                }})
            }}
          />
        </ItemGrid>
				{/* show the actual map */}
        <ItemGrid xs={12} sm={12} md={12}>
          <Maps
            onChange={location => this.setState({location})}
            height={250}
            lat={Number(this.state.location.lat || 40.749)}
            lng={Number(this.state.location.lng || -73.985)}
          />
        </ItemGrid>
      </Grid>
    );
  }

	// display the details of a Reward
	renderReward() {
		// get the reward ID from the state
    const rewardId = this.state.selectedReward
		// and then find it in the database
    const reward = this.props.rewards.find(({id}) => id === rewardId);
		// if there's no reward to display, don't display anything
    if (!reward) return null;
		// otherwise, return this big ol card
    return (
      <Card>
        <CardContent>
          <Grid container>
            <ItemGrid xs={12} sm={12} md={12}>
							{/* display reward title */}
              <h5>{reward.title}</h5>
              <Grid container>
              	<ItemGrid xs={12} sm={12} md={3}>
									{/* Render and give option to save QR Code */}
                  <h5>QR Code</h5>
                  <h6>Click to save</h6>
                 	<div className="HpQrcode">
                    <QRCode value={rewardId}
											onClick={() => this.downloadQR(reward)}/>
                  </div>
                </ItemGrid>
								{/* either show the details of the reward
									or the check-in location on the map */}
                <ItemGrid xs={12} sm={12} md={9}>
                	{ this.renderMap() }
                </ItemGrid>
              </Grid>
            </ItemGrid>
					</Grid>
					{/* show Update/Remove Location/Delete buttons */}
          <div style={{textAlign: 'center'}}>
            <Button primary={true} onClick={() => this.onChangeCoords()}>
							Update
						</Button>
            {this.state.location ?
							<Button primary={true}
								onClick={() => this.onChangeCoords({ remove: true })}>
								REMOVE LOCATION
							</Button>
							: null}
            <Button primary={true} onClick={() => this.onDeleteReward()}>
							Delete
						</Button>
          </div>
       </CardContent>
      </Card>
    )
  } // end of renderReward

	// determine the user that has checked in the most
	getTopPointEarner() {
		const allUsers = this.props.allUserInfo;
		let topUser = '';
		let toTheTop = 0;

		for (let i = 0; i < allUsers.length; ++i) {
			let user = allUsers[i];
			if (user.totalPointsEarned > toTheTop) {
				toTheTop = user.totalPointsEarned;
				topUser = user.name;
			}
		}
		return topUser;
	}

	// saveReport - takes the user data and prints it to a fancy .pdf
	// PDF size - 215.9 by 279.4 mm
	// to center text, place it at x = 107.95 and Align: Center
	saveReportPDF() {
		let totalHeldPoints = this.props.totalPoints;
		let totalRedemptions = this.props.totalRedemptions;
		let totalPointsEarned = (totalHeldPoints + totalRedemptions * 10);
		let totalUsers = this.props.allUserInfo.length;
		if (totalUsers === 0) {
			totalUsers = 1;
		} // I don't think you CAN have zero users
		//but we also don't want to divide by zero, either
		let avgHeldPoints = parseFloat(totalHeldPoints / totalUsers).toPrecision(3);
		let avgPointsEarned = parseFloat(totalPointsEarned / totalUsers).toPrecision(3);
		let avgRedemptions = parseFloat(totalRedemptions / totalUsers).toPrecision(3);
		let topPointEarner = this.getTopPointEarner();

		let imageData = 'data:image/jpeg;base64,' + header;
		let date = new Date();

		//pdf.setFont(fontName, fontStyle);
		// create the PDF
		// header with letterhead and title
		var pdf = new jsPDF({format: 'letter'});
		pdf.addImage(imageData, 'JPG', 82.95, 12.5, 50, 30, 'header', 'FAST', 0);
		pdf.setFontSize(24);
		pdf.setTextColor(15);
		pdf.text('Your Application Usage Report', 107.95, 57.5, {align: 'center'});
		pdf.line(25.4, 63, 190.5, 63)
		pdf.setFontSize(18);
		// the actual data
		pdf.text('Total Held Points: ' + totalHeldPoints, 25.4, 75);
		pdf.text('Total Redemptions: ' + totalRedemptions, 25.4, 90);
		pdf.text('Total Points Earned: ' + totalPointsEarned, 25.4, 105);
		pdf.text('Total Number of Users: ' + totalUsers, 25.4, 120);
		pdf.text('Average Held Points: ' + avgHeldPoints, 25.4, 135);
		pdf.text('Average Points Earned: ' + avgPointsEarned, 25.4, 150);
		pdf.text('Average Redemptions: ' + avgRedemptions, 25.4, 165);
		pdf.text('Top Point Earner: ' + topPointEarner, 25.4, 180);
		pdf.line(25.4, 240, 190.5, 240)
		pdf.text('Report Date: ' + date.toDateString(), 107.95, 250, {align: 'center'});
		// and then save it
		pdf.save('App-Report.pdf');
	}

	// main render function
  	render() {
		// make sure only authorized Users proceed
		// check for admin rights in general
		if (!this.props.user.hasOwnProperty('admin')) {
			return (
				<Redirect from={'rewards'} to={'dashboard'} key={'invalid'} />
			);
		}
		// check for rights for this page in particular
		if (!this.props.user.admin.master &&
			!this.props.user.admin.hasOwnProperty('rewards'))
		{
			return (
				<Redirect from={'rewards'} to={'dashboard'} key={'noTicket'} />
			);
		}

		// set props
		const { rewards, settings } = this.props;

		// render return
    return (
			<Grid container>
      	<ItemGrid xs={12} sm={12} md={6}>
					{/* Top left Rewards section */}
          <RegularCard
            cardTitle="Rewards"
            content={
              <div>
                <Grid container>
                  <ItemGrid xs={12} sm={12} md={12}>
									{/* show the New Reward modal */}
                  {this.state.showModal &&
                    <ReactModal isOpen={this.state.showModal}
                      onRequestClose={this._onCloseModal.bind(this)}
                      closeTimeoutMS={450}
                      contentLabel={'New Reward'}
                      ariaHideApp={false}
                      style={customModalStyles}
                      >
                      <ModalHeader>{'New Reward'}</ModalHeader>
                      <ModalContent>
												{/* Set Title of New Reward */}
                        <TextField
                          label={'Title'}
                          value={this.state.title}
                          style={{ width: '100%' }}
                          onChange={(evt) => {this.setState({ title: evt.target.value })}}
													/><br/>
                      </ModalContent>
                      <ModalFooter>
												{/* Create/Edit buttons */}
                        <Button variant='raised'
													primary={true}
													onClick={(e) => this._onAddReward()}>
                          Create
                        </Button>
                        <Button variant='raised' style={{ marginLeft: 20 }}
													onClick={(e) => {this.setState({ showModal: false })}}>
                          Cancel
                        </Button>
                      </ModalFooter>
                    </ReactModal>
                	}
                  <h5>Rewards</h5>
									{/* If loading, show das circle boi */}
                  {this.state.isLoading &&
                    <div style={{padding: 10, textAlign: 'center'}}>
											<CircularProgress />
										</div>
                  }
                  {!this.state.isLoading &&
                    rewards.map((reward, index) => {
                      let color = "info";
                      if (this.state.selectedReward === reward.id) {
                        color = "primary";
                      }
											/* Map all the Rewards into clickable objects */
		                	return (
												<div key={reward.id}
													style={{
														display: 'flex',
														alignItems: 'flex-start',
														justifyContent: 'space-between'
													}}
												>
			                    <SnackbarContent
			                    	fullWidth
			                      icon={PinDrop}
			                      message={
			                        reward.title ? reward.title : ''
			                      }
			                      color={color}
			                      onClick={() => this.onSelectReward(reward)}
			                    />
                        </div>
											);
                    })
                  }
									{/* If there are no Rewards to show, display as such */}
                  {!this.state.isLoading && isEmpty(rewards) &&
                    <div style={{padding: 10, textAlign: 'center'}}>
											No Rewards.
										</div>
                  }
                  </ItemGrid>
                </Grid>
                <div style={{textAlign: 'center'}}>
                  <Button primary={true}
										onClick={this._onShowModal.bind(this)}>Add New Reward</Button>
                </div>
              </div>
            }
          />
        </ItemGrid>
				{/* Settings card on top right */}
        <ItemGrid xs={12} sm={12} md={6}>
	        <RegularCard
            cardTitle="Settings"
            cardSubtitle={
              <P>
                Points to Reward, Minimum Time Between Check-Ins, Geo Check-In Radius
              </P>
            }
						content={
	          	<div style={{opacity: this.state.settingsLoaded ? 1 : 0}}>
	            	<Grid container>
									{/* Required points needed for redemption input */}
	              	<ItemGrid xs={12} sm={12} md={4}>
	                	<CustomInput
	                  	labelText="# of Points to Loyalty Reward"
	                    formControlProps={{
	                    	fullWidth: true
	                    }}
	                    inputProps={{
	                    	value: this.state.points,
	                      endAdornment: <InputAdornment position="end">Points</InputAdornment>,
	                      onChange: (evt) => this.setState({points: Number(evt.target.value)})
	                    }}
	                  />
	                  </ItemGrid>
										{/* What Points can be Redeemed for */}
	                  <ItemGrid xs={12} sm={12} md={4}>
	                    <CustomInput
	                      labelText="Loyalty Reward Value (Text)"
	                      formControlProps={{
	                        fullWidth: true
	                      }}
	                      inputProps={{
	                        value: this.state.reward,
	                        onChange: (evt) => this.setState({reward: evt.target.value})
	                      }}
	                    />
	                  </ItemGrid>
										{/* Minimum time between check-ins */}
	                  <ItemGrid xs={12} sm={12} md={4}>
	                    <CustomInput
	                      labelText="Time Between Check-Ins"
	                      formControlProps={{
	                        fullWidth: true
	                      }}
	                      inputProps={{
	                        value: this.state.delay,
	                        endAdornment: <InputAdornment position="end">Hours</InputAdornment>,
	                        onChange: (evt) => this.setState({delay: Number(evt.target.value)})
	                      }}
	                    />
	                  </ItemGrid>
										{/* Upload a background image to show up on the application
											for the reward card component */}
	                  <ItemGrid xs={12} sm={12} md={8}>
	                    <InputLabel>
	                      Background image
	                    </InputLabel>
	                    <UploadButton
	                      storage="logo"
	                      className="image-upload-button big-image"
	                      value={this.state.loyaltyCardBackground}
	                      onUploadComplete=
													{loyaltyCardBackground =>
														this.setState({ loyaltyCardBackground} )}
	                    />
	                  </ItemGrid>
										{/* Specify the maximum distance from the locale
											for check-in to be enabled*/}
	                  <ItemGrid xs={12} sm={12} md={4}>
	                    <CustomInput
	                      labelText="Geo Check-In Radius (km)"
	                      formControlProps={{
	                        fullWidth: true
	                      }}
	                      inputProps={{
	                        value: this.state.geoRadius,
	                        endAdornment: <InputAdornment position="end">
															Kilometers
														</InputAdornment>,
	                        onChange: (evt) => {
								this.setState({geoRadius: evt.target.value})
							}
	                      }}
	                    />
	                  </ItemGrid>
					  <ItemGrid xs={12} sm={12} md={4}>
					 	 <FormControlLabel
							control={
								<Checkbox
								checked={this.state.enableQR}
								onChange={(e, c) => {this.setState({enableQR: c })}}
								value="checked"
								/>
							}
							label="Enable QR Scan"
							/>
						<FormControlLabel
							control={
								<Checkbox
								disabled={!this.state.enableQR}
								checked={this.state.geoRequiredOnScan}
								onChange={(e, c) => {this.setState({ geoRequiredOnScan: c })}}
								value="checked"
								/>
							}
							label="Require User On-site"
							/>
	                  </ItemGrid>
					  <ItemGrid xs={12} sm={12} md={4}>
						<FormControlLabel
							control={
								<Checkbox
								checked={this.state.enableCheckin}
								onChange={(e, c) => {this.setState({ enableCheckin: c })}}
								value="checked"
								/>
							}
							label="Enable Checkin"
							/>
	                  </ItemGrid>
	                </Grid>
									{/* the Save button */}
	                <div style={{textAlign: 'center'}}>
	                  <Button
	                    disabled={
	                      this.state.points === settings.points &&
	                      this.state.reward === settings.reward &&
	                      this.state.geoRadius === settings.geoRadius &&
	                      this.state.loyaltyCardBackground === settings.loyaltyCardBackground &&
	                      this.state.delay === settings.delay &&
						  this.state.geoRequiredOnScan === settings.geoRequiredOnScan &&
						  this.state.enableCheckin === settings.enableCheckin &&
						  this.state.enableQR === settings.enableQR
	                    }
	                    primary
	                    onClick={() => this.saveRewardSettings()}
	                  >
	                    Save
                    </Button>
	                </div>
	              </div>
	           	}
	          />
	      </ItemGrid>
      	{ this.state.selectedReward !== null ? this.renderReward() : null }
				{/* Reporting section */}
					{/*
			    'Name' field displays user's 'name'
					'Email' field displays user Email
					'Reward Points' - currently held points
			    'Total Points Earned' - includes from past redemptions
			    'Last Check-In' - most recent geo check-in
			    'Redemptions' - total number of times user has Redeemed a Reward
			    'Last Redemption' - most recent reward redeem time
				*/}
        <RegularCard cardTitle="Reporting"
        	content={
            <div>
              <p>
                Total Held Points: {this.props.totalPoints}
                <br/>
                Total Redemptions: {this.props.totalRedemptions}
								<br/>
								Total Earned Points: {this.props.totalPoints + this.props.totalRedemptions * 10}
              </p>
          		<ReactTable
                data={this.props.allUserInfo}
                columns={columns}
                defaultPageSize={5}
                />
              <Button variant='raised' style={{ marginLeft: 0 }} onClick={(e) => {this.saveReportPDF()}}>
                Downlaod PDF
              </Button>
			  	<CSVLink
				  data={this.props.allUserInfo}
				  headers={this.state.headers}
				  filename={`${appInfo.APP_TITLE}Report.csv`}
				  className="btn btn-primary"
				>
					Download CSV
				</CSVLink>
            </div>
          }
      	/>
      </Grid>
    );
  }
}
// dispatch map
const mapDispatchToProps = {
	createNewReward,
  loadRewards,
  deleteReward,
  updateReward,
  getSettings,
  saveRewardSettings,
	getUserData,
};
// fetch state
const mapStateToProps = state => {
  let allUserInfo = state.rewardReducer.allUserInfo;
  let rewards = state.rewardReducer.rewards;
  if (rewards.length > 0) {
    let reward = rewards[0];
    let checkins = reward.rewards;
    for (let a = 0; a < allUserInfo.length; ++a) {
	  let id = allUserInfo[a].id;
	  if(checkins) {
		if (checkins.hasOwnProperty(id)) {
			allUserInfo[a].lastCheckIn = checkins[id].date;
		}
	}
    }
  }
  return {
	rewards: state.rewardReducer.rewards,
  	isLoading: state.rewardReducer.isLoading,
  	settings: state.rewardReducer.settings,
	user: state.authReducer.user,
	totalPoints: state.rewardReducer.totalPoints,
	totalRedemptions: state.rewardReducer.totalRedemptions,
	allUserInfo: allUserInfo,
}};
// export
export default connect(mapStateToProps, mapDispatchToProps)(RewardsView)
